import { AppContext, IAppContext } from 'appState/appContext';
import { useContext, useEffect } from 'react';

export const useNamedHeader = (name: string | null | undefined) => {
	const { setEntityNameForHeader } = useContext<IAppContext>(AppContext);

	useEffect(() => {
		name && setEntityNameForHeader(name);

		return () => {
			setEntityNameForHeader('');
		};
	}, [name]);
};
